import React, { useState, useEffect } from "react";
import { X, BookOpen, ArrowLeft } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export const FourCModal = ({ open, onClose }) => {
  const { lang, t } = useLang();
  const [zoom, setZoom] = useState(false);

  useEffect(() => { if (!open) setZoom(false); }, [open]);
  if (!open) return null;

  const src = `/fiches/4c/4c-${lang === "fr" ? "fr" : "en"}.png`;
  const heading = lang === "fr" ? "Les 4C — Gemmologie" : "The 4Cs — Gemmology";
  const subhead = lang === "fr"
    ? "Couleur • Pureté • Taille • Carat — les 4 critères d'évaluation"
    : "Colour • Clarity • Cut • Carat — the 4 evaluation criteria";

  return (
    <div
      data-testid="fourc-modal"
      className="fixed inset-0 z-50 flex items-start justify-center p-4 md:p-8 bg-black/85 backdrop-blur-md overflow-y-auto"
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative w-full max-w-5xl my-6 rounded-sm bg-[#050B1E] border border-[#C1A661]/40 p-4 md:p-10"
        style={{ boxShadow: "inset 0 0 120px rgba(193,166,97,0.10)" }}
      >
        <button
          data-testid="fourc-close-btn"
          onClick={onClose}
          className="absolute top-4 right-4 text-[#A1A7B3] hover:text-[#F8F5EE] transition-colors z-10"
          aria-label={t.modal.close}
        >
          <X size={22} strokeWidth={1.4} />
        </button>

        <div className="flex items-center gap-3 mb-6">
          <BookOpen size={22} strokeWidth={1.4} className="text-[#C1A661]" />
          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#C1A661]">
              {lang === "fr" ? "Guide gemmologique" : "Gemmological guide"}
            </div>
            <h2 className="font-serif text-2xl md:text-4xl font-light text-[#F8F5EE] leading-tight">
              {heading}
            </h2>
            <p className="mt-1 text-[12px] text-[#A1A7B3] font-light italic">{subhead}</p>
          </div>
        </div>

        <div className="space-y-2" data-testid="fourc-content">
          <button
            type="button"
            onClick={() => setZoom(true)}
            className="block w-full text-left"
            aria-label={t.fiche.viewFullSize}
          >
            <img
              src={src}
              alt={heading}
              data-testid="fourc-image"
              className="w-full h-auto rounded-sm border border-[#C1A661]/25 cursor-zoom-in hover:brightness-105 transition"
              style={{ backgroundColor: "#F8F5EE" }}
              loading="lazy"
            />
          </button>
          <button
            type="button"
            onClick={() => setZoom(true)}
            className="inline-block text-[10px] tracking-[0.25em] uppercase text-[#C1A661] hover:text-[#E2CFA4] transition-colors"
          >
            {t.fiche.viewFullSize} ↗
          </button>
        </div>
      </div>

      {zoom && (
        <div
          data-testid="fourc-zoom-overlay"
          className="fixed inset-0 z-[60] bg-black/95 flex flex-col"
          onClick={(e) => { e.stopPropagation(); setZoom(false); }}
        >
          <div className="flex items-center justify-between p-4 border-b border-[#C1A661]/20 bg-[#050B1E]/95">
            <button
              onClick={(e) => { e.stopPropagation(); setZoom(false); }}
              className="flex items-center gap-2 px-4 py-2 rounded-full border border-[#C1A661]/40 hover:border-[#C1A661] text-[#E2CFA4] hover:text-[#F8F5EE] text-xs tracking-[0.25em] uppercase transition-colors"
            >
              <ArrowLeft size={14} strokeWidth={1.5} />
              <span>{lang === "fr" ? "Retour" : "Back"}</span>
            </button>
            <button
              onClick={(e) => { e.stopPropagation(); setZoom(false); }}
              className="text-[#A1A7B3] hover:text-[#F8F5EE] transition-colors"
              aria-label={t.modal.close}
            >
              <X size={22} strokeWidth={1.4} />
            </button>
          </div>
          <div className="flex-1 overflow-auto p-4 md:p-8 flex items-start justify-center" onClick={(e) => e.stopPropagation()}>
            <img
              src={src}
              alt={heading}
              className="max-w-full h-auto rounded-sm shadow-2xl"
              style={{ backgroundColor: "#F8F5EE" }}
            />
          </div>
        </div>
      )}
    </div>
  );
};
